import './userIdentity.scss';

import { SyntheticEvent } from 'react';
import { FaPhone, FaUserCircle } from 'react-icons/fa';
import { MdBadge } from 'react-icons/md';

import { useWebContext } from '@/resources/hooks/useWebContext';
import { ClientTypes } from '@/services/clients';
import { maskDocument, maskPhone } from '@/services/global';
import { IClient } from '@/store/ducks/order/types';

import userCircleImg from '../../assets/images/user-circle-solid.jpg';

export default function UserIdentity({
  client,
  showCPF = true,
}: {
  client: IClient | undefined;
  showCPF?: boolean;
}) {
  const { setShowCPFModal } = useWebContext();

  const handleAddCPF = () => {
    setShowCPFModal(true);
  };

  return (
    <div className="d-flex align-items-center p-2 pl-4">
      <div className="avatar">
        {client?.avatar ? (
          <img
            className="img-fluid"
            alt={client?.name}
            src={client?.avatar}
            onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
              e.currentTarget.src = userCircleImg;
            }}
          />
        ) : (
          <FaUserCircle className="icon" />
        )}
      </div>

      <div className="info">
        <h5>{client?.name}</h5>
        {client?.type !== ClientTypes.ANONYMOUS && (
          <h6 className="d-flex">
            <FaPhone color="#CFCFCF" className="pr-2" size={20} />
            {maskPhone(client?.identification ?? '', true)}
          </h6>
        )}

        {client?.type !== ClientTypes.ANONYMOUS && !client?.cpf && (
          <h6
            className="badge badge-secondary cursor-pointer"
            onClick={handleAddCPF}
            style={{ color: '#fff' }}
          >
            Informar CPF +
          </h6>
        )}
        {client?.type !== ClientTypes.ANONYMOUS && client?.cpf && showCPF && (
          <h6>
            <MdBadge color="#CFCFCF" className="pr-2" size={20} />
            {maskDocument(client?.cpf, true)}
          </h6>
        )}
      </div>
    </div>
  );
}
